"use client";

import { c as _c } from "react/compiler-runtime";
import { AnimatePresence, motion } from "framer-motion";
import { usePathname } from "next/navigation";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CloseMobileNavIcon from "@/assets/svg/close-mobile-nav.svg";
import { cn } from "@/lib/utils";
import { getCurrentLanguageInClient, useLocaleRouter } from "@/lib/utils.client";
import { useTracking } from "@/track";
import { CMSImage, CMSLink, CMSText } from "../../../modules/cms/components/cms-items";
import type { CmsContentHeader, HeaderConfigType, ImageTextItem } from "../../../modules/cms/schema";
import { getLinkUrl, getTranslatedText } from "../../../modules/cms/utils.server";
import { UserAccountInHeader } from "../../../modules/users/account/user-account";

// 图文类型菜单项渲染
function MobileImageTextItem(t0) {
  const $ = _c(55);
  const {
    item,
    layoutType,
    parentTitle
  } = t0;
  const {
    track,
    TrackingEventType
  } = useTracking();
  const itemText = item.text;
  let t1;
  if ($[0] !== item.link) {
    t1 = getLinkUrl(item.link) || "#";
    $[0] = item.link;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageCardHref = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getCurrentLanguageInClient();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const lang = t2;
  let t3;
  if ($[3] !== TrackingEventType.CLICK || $[4] !== imageCardHref || $[5] !== itemText || $[6] !== parentTitle || $[7] !== track) {
    t3 = () => {
      track("PopMartGlobalWebNavigationClick", {
        navigation_name: getTranslatedText(lang, itemText),
        navigation_type: "second_navigation",
        main_navigation_name: getTranslatedText(lang, parentTitle),
        second_navigation_name: getTranslatedText(lang, itemText),
        third_navigation_name: "",
        jump_url: imageCardHref
      }, TrackingEventType.CLICK);
    };
    $[3] = TrackingEventType.CLICK;
    $[4] = imageCardHref;
    $[5] = itemText;
    $[6] = parentTitle;
    $[7] = track;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleClick = t3;
  if (layoutType === "smallImageLeftRight") {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="absolute inset-0 origin-center scale-[0.5] transform rounded-full border border-[#DDDDDD]" style={{
        width: "6.67rem",
        height: "6.67rem",
        left: "-1.67rem",
        top: "-1.67rem"
      }} />;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== item.image) {
      t5 = <div className="relative h-[3.33rem] w-[3.33rem]">{t4}<CMSImage image={item.image} width={50} height={50} className="relative z-10 h-[3.33rem] w-[3.33rem] rounded-full object-contain" priority={true} /></div>;
      $[10] = item.image;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== handleClick) {
      t6 = () => handleClick();
      $[12] = handleClick;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    let t7;
    if ($[14] !== itemText) {
      t7 = <CMSText text={itemText} className="font-[DINPro-Regular] text-[0.8rem] font-normal text-[#000000]" />;
      $[14] = itemText;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t6 || $[17] !== t7) {
      t8 = <div className="cursor-pointer" onClick={t6}>{t7}</div>;
      $[16] = t6;
      $[17] = t7;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    let t9;
    if ($[19] !== t5 || $[20] !== t8) {
      t9 = <div className="flex w-full flex-row items-center gap-3 rounded text-base">{t5}{t8}</div>;
      $[19] = t5;
      $[20] = t8;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    let t10;
    if ($[22] !== item.link || $[23] !== t9) {
      t10 = <CMSLink link={item.link}>{t9}</CMSLink>;
      $[22] = item.link;
      $[23] = t9;
      $[24] = t10;
    } else {
      t10 = $[24];
    }
    return t10;
  }
  if (layoutType === "mediumImageTopBottom") {
    let t4;
    if ($[25] !== item.image) {
      t4 = <CMSImage image={item.image} width={214} height={214} className="object-contain" priority={true} />;
      $[25] = item.image;
      $[26] = t4;
    } else {
      t4 = $[26];
    }
    let t5;
    if ($[27] !== handleClick) {
      t5 = () => handleClick();
      $[27] = handleClick;
      $[28] = t5;
    } else {
      t5 = $[28];
    }
    let t6;
    if ($[29] !== itemText) {
      t6 = <CMSText text={itemText} className="font-[DINPro-Regular] text-[3.2vw] font-normal text-[#000000]" />;
      $[29] = itemText;
      $[30] = t6;
    } else {
      t6 = $[30];
    }
    let t7;
    if ($[31] !== t5 || $[32] !== t6) {
      t7 = <div className="mt-2.5 w-full text-center" onClick={t5}>{t6}</div>;
      $[31] = t5;
      $[32] = t6;
      $[33] = t7;
    } else {
      t7 = $[33];
    }
    let t8;
    if ($[34] !== t4 || $[35] !== t7) {
      t8 = <div className="flex flex-col items-start justify-center">{t4}{t7}</div>;
      $[34] = t4;
      $[35] = t7;
      $[36] = t8;
    } else {
      t8 = $[36];
    }
    let t9;
    if ($[37] !== item.link || $[38] !== t8) {
      t9 = <CMSLink link={item.link}>{t8}</CMSLink>;
      $[37] = item.link;
      $[38] = t8;
      $[39] = t9;
    } else {
      t9 = $[39];
    }
    return t9;
  }
  if (layoutType === "largeImageTopBottom") {
    let t4;
    if ($[40] !== item.image) {
      t4 = <CMSImage image={item.image} width={343} height={142} className="aspect-[343/142] w-full" priority={true} />;
      $[40] = item.image;
      $[41] = t4;
    } else {
      t4 = $[41];
    }
    let t5;
    if ($[42] !== handleClick) {
      t5 = () => handleClick();
      $[42] = handleClick;
      $[43] = t5;
    } else {
      t5 = $[43];
    }
    let t6;
    if ($[44] !== itemText) {
      t6 = <CMSText text={itemText} className="font-['DINPro-Regular'] text-[0.8rem] font-normal text-black" />;
      $[44] = itemText;
      $[45] = t6;
    } else {
      t6 = $[45];
    }
    let t7;
    if ($[46] !== t5 || $[47] !== t6) {
      t7 = <div className="mt-[0.67rem] w-full text-left" onClick={t5}>{t6}</div>;
      $[46] = t5;
      $[47] = t6;
      $[48] = t7;
    } else {
      t7 = $[48];
    }
    let t8;
    if ($[49] !== t4 || $[50] !== t7) {
      t8 = <div className="mb-[1.25rem] flex w-full flex-col items-start justify-center">{t4}{t7}</div>;
      $[49] = t4;
      $[50] = t7;
      $[51] = t8;
    } else {
      t8 = $[51];
    }
    let t9;
    if ($[52] !== item.link || $[53] !== t8) {
      t9 = <CMSLink link={item.link}>{t8}</CMSLink>;
      $[52] = item.link;
      $[53] = t8;
      $[54] = t9;
    } else {
      t9 = $[54];
    }
    return t9;
  }
  return null;
}

// 公共的菜单内容组件
function MobileMenuContent(t0) {
  const $ = _c(16);
  const {
    navItems
  } = t0;
  const {
    t
  } = useTranslation();
  const {
    track,
    TrackingEventType
  } = useTracking();
  const [selectedMenu, setSelectedMenu] = useState(null);
  const router = useLocaleRouter();
  const lang = getCurrentLanguageInClient();
  const isImageTextType = _temp;
  const handleMenuClick = item => {
    track("PopMartGlobalWebNavigationClick", {
      navigation_name: getTranslatedText(lang, item.title_trans),
      navigation_type: "main_navigation",
      main_navigation_name: getTranslatedText(lang, item.title_trans),
      second_navigation_name: "",
      third_navigation_name: "",
      jump_url: item.type === "link" ? getLinkUrl((item.data as any).link) || "#" : "#"
    }, TrackingEventType.CLICK);
    if (item.type === "link") {
      const url = getLinkUrl((item.data as any).link) || "#";
      router.push(url);
      return;
    }
    if (isImageTextType(item.type)) {
      setSelectedMenu(item);
    }
  };
  let t1;
  let t2;
  if ($[0] !== navItems) {
    t1 = () => {
      if (navItems.length > 0) {
        const firstImageTextItem = navItems.find(item_0 => isImageTextType(item_0.type));
        if (firstImageTextItem) {
          setSelectedMenu(firstImageTextItem);
        }
      }
    };
    t2 = [navItems, isImageTextType];
    $[0] = navItems;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = "w-[6.875rem] overflow-y-auto bg-[#F1F1F1]";
  const t4 = navItems?.map(item_1 => <div key={item_1.id} className={cn("cursor-pointer h-12.5 flex items-center px-4", selectedMenu?.id === item_1.id ? "bg-white text-[#D2001E]" : "text-black hover:bg-gray-100")} onClick={() => handleMenuClick(item_1)}><div className="text-left line-clamp-2 wrap-break-words w-full"><CMSText text={item_1.title_trans || t("header.noTitle")} className="text-xs font-normal break-all" /></div></div>);
  let t5;
  if ($[3] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== selectedMenu) {
    t6 = selectedMenu && <div>{selectedMenu.type === "largeImageTopBottom" && (selectedMenu.data as any).imageTextItems && <div>{(selectedMenu.data as any).imageTextItems.map((item_2, idx) => <MobileImageTextItem key={`large-${idx}-${JSON.stringify(item_2.text)}`} item={item_2} layoutType="largeImageTopBottom" parentTitle={selectedMenu.title_trans} />)}</div>}{selectedMenu.type === "mediumImageTopBottom" && (selectedMenu.data as any).imageTextItems && <div className="grid grid-cols-2 gap-x-[calc(11/375*100vw)] gap-y-[calc(20/375*100vw)] sm:gap-x-[calc(22/750*100vw)] sm:gap-y-[calc(40/750*100vw)]">{(selectedMenu.data as any).imageTextItems.map((item_3, idx_0) => <MobileImageTextItem key={`medium-${idx_0}-${JSON.stringify(item_3.text)}`} item={item_3} layoutType="mediumImageTopBottom" parentTitle={selectedMenu.title_trans} />)}</div>}{selectedMenu.type === "smallImageLeftRight" && (selectedMenu.data as any).imageTextItems && <div className="flex flex-col gap-3">{(selectedMenu.data as any).imageTextItems.map((item_4, idx_1) => <MobileImageTextItem key={`small-${idx_1}-${JSON.stringify(item_4.text)}`} item={item_4} layoutType="smallImageLeftRight" parentTitle={selectedMenu.title_trans} />)}</div>}{selectedMenu.type === "textOnly" && (selectedMenu.data as any).textItems && <div className="flex flex-col gap-4">{(selectedMenu.data as any).textItems.map(_temp2)}</div>}</div>;
    $[5] = selectedMenu;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== selectedMenu || $[8] !== t) {
    t7 = !selectedMenu && <div className="flex h-full items-center justify-center text-gray-500 leading-relaxed">{t("header.selectMenuToView")}</div>;
    $[7] = selectedMenu;
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className="flex-1 overflow-y-auto p-4">{t6}{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}

// 合并的移动端菜单弹窗组件
function _temp2(item_5, idx_2) {
  return <CMSLink key={`text-${idx_2}-${JSON.stringify(item_5.text)}`} link={item_5.link}><div className="mb-2 flex w-full flex-row items-center gap-3 rounded px-2 text-base"><span className="cursor-pointer"><CMSText text={item_5.text} className="font-[DINPro-Regular] text-[0.8rem] font-normal text-[#000000]" /></span></div></CMSLink>;
}
function _temp(type) {
  return ["smallImageLeftRight", "mediumImageTopBottom", "largeImageTopBottom", "textOnly"].includes(type);
}
function MobileMergedMenuDrawer(t0) {
  const $ = _c(7);
  const {
    open,
    navItems,
    onClose
  } = t0;
  const pathname = usePathname();
  if (!open) {
    return null;
  }
  let t1;
  if ($[0] !== navItems || $[1] !== onClose || $[2] !== open || $[3] !== pathname) {
    t1 = open && <Fragment><motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 0.5
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-70 bg-black" style={{
        backgroundColor: "rgba(0,0,0,0.3)"
      }} onClick={onClose} /><motion.div initial={{
        x: "100%"
      }} animate={{
        x: 0
      }} exit={{
        x: "100%"
      }} transition={{
        duration: 0.3,
        ease: "easeOut"
      }} className="fixed top-0 right-0 z-80 flex h-full w-screen max-w-[100vw] flex-col overflow-hidden bg-white shadow-lg" style={{
        boxShadow: "-2px 0 8px rgba(0,0,0,0.08)"
      }}><div className="flex items-center justify-between pt-3 pr-3 pl-4">{!pathname.includes("/category") && <UserAccountInHeader showLabel={true} />}<div className="flex-1" /><div className="flex size-5.5 items-center justify-center" onClick={onClose}><CloseMobileNavIcon className="size-5.5" /></div></div><div className={cn("z-100 flex flex-1 overflow-hidden", pathname.includes("/category") ? "mt-4" : "mt-4")}><MobileMenuContent navItems={navItems} /></div></motion.div></Fragment>;
    $[0] = navItems;
    $[1] = onClose;
    $[2] = open;
    $[3] = pathname;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <AnimatePresence>{t1}</AnimatePresence>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}

// 内嵌式菜单组件（用于category页面）
function MobileInlineMenu(t0) {
  const $ = _c(7);
  const {
    navItems,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex h-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== navItems) {
    t2 = <MobileMenuContent navItems={navItems} />;
    $[2] = navItems;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
interface MobileMenuListProps {
  navItems: CmsContentHeader[];
  className?: string;
  open?: boolean;
  onClose?: () => void;
}
export function MobileMenuList(t0) {
  const $ = _c(15);
  const {
    navItems,
    className,
    open,
    onClose
  } = t0;
  const pathname = usePathname();
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (open) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return _temp3;
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onClose || $[4] !== open) {
    t3 = () => {
      if (open && onClose) {
        onClose();
      }
    };
    $[3] = onClose;
    $[4] = open;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== pathname) {
    t4 = [pathname];
    $[6] = pathname;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  if (typeof open === "boolean" && onClose) {
    let t5;
    if ($[8] !== navItems || $[9] !== onClose || $[10] !== open) {
      t5 = <MobileMergedMenuDrawer open={open} navItems={navItems} onClose={onClose} />;
      $[8] = navItems;
      $[9] = onClose;
      $[10] = open;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== className || $[13] !== navItems) {
    t5 = <MobileInlineMenu navItems={navItems} className={className} />;
    $[12] = className;
    $[13] = navItems;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
function _temp3() {
  document.body.style.overflow = "";
}